import Grid from '../../Common/Grid/index';
import getNoDataCellComponent from '../../Common/NoDataCellComponent/index';
import React from 'react';
import ItemIcon from '@material-ui/icons/Favorite';
import _ from 'lodash';
import moment from 'moment';

const styles = {
  type: {
    display: 'flex',
    alignItems: 'center',
  }
}

const COLUMNS = [
    { name: 'date', title: 'Date' },
    { name: 'name', title: 'Name' },
    { name: 'notes', title: 'Notes' },
  ];

const COLUMN_EXTENSIONS = [
  { columnName: 'date', width: 130 },
  { columnName: 'name', width: 150 },
];

const getCellComponent = (onEdit, onRemove) => ({ row, column, value }) => {
  switch (column.name) {
    case 'date':
      return moment(value).format('lll');
    default:
      return value;
  }

};

const NotesGrid = ({ notes, onEdit, onRemove }) => {
  return <Grid
    columns={COLUMNS}
    columnExtensions={COLUMN_EXTENSIONS}
    cellComponent={getCellComponent(onEdit, onRemove)}
    fetch={_.noop}
    data={{ data: notes }}
    noDataCellComponent={getNoDataCellComponent(<ItemIcon style={styles.noData}/>, 'notes')}
  />;
};

export default NotesGrid;



// WEBPACK FOOTER //
// ./src/components/Tasks/NotesGrid/index.js